import './index.css';
import React from 'react';
import MainWindow from './MainWindow.jsx';

function App() {
  return <MainWindow />;
}

export default App;
